import React, { useState, useEffect, useCallback } from 'react';
import { oilApi } from './oilApi';

// RÁDIO DO SUBMUNDO — faixa voadora que passa logo abaixo da barra de recursos
export default function OilRadio({ tick }) {
  const [feed, setFeed] = useState([]);

  const load = useCallback(async () => {
    try { const r = await oilApi.get('/feed'); setFeed(r.data.events || []); } catch {}
  }, []);
  useEffect(() => { load(); }, [load, tick]);

  const msgs = feed.map((e) => e.message).filter(Boolean);
  if (msgs.length === 0) return null;
  const line = msgs.join('   ✦   ');

  return (
    <div className="pointer-events-none relative mx-auto -mt-1 w-[94%] overflow-hidden rounded-full border border-amber-700/70 bg-black/80 py-1 shadow-[0_4px_14px_rgba(0,0,0,0.6)] backdrop-blur"
      data-testid="oil-radio">
      <div className="flex items-center px-3">
        <div className="relative min-w-0 flex-1 overflow-hidden">
          <p className="inline-block w-max whitespace-nowrap text-[10px] font-bold text-amber-100/90" data-testid="oil-radio-line"
            style={{ animation: `oil-radio-scroll ${Math.max(20, line.length / 6)}s linear infinite` }}>
            {line}   ✦   {line}
          </p>
        </div>
      </div>
      <style>{`@keyframes oil-radio-scroll {
        from { transform: translateX(0); }
        to { transform: translateX(-50%); }
      }`}</style>
    </div>
  );
}
